module.exports = __webpack_public_path__ + "static/media/5@2x.41bb24ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_150/img/5@2x.png
// module id = 1477
// module chunks = 0